module.exports = {
  modelsData: () => {
    return {
      "IONIQ 5 EV-POWER": {
        "model": "./models/IONIQ_5_PREMIUM/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },
      "TUCSON HEV LIMITED": {
        "model": "./models/TUCSON_LIMITED/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },
      "PALISADE SPORT": {
        "model": "./models/PALISADE_SPORT/scene.glb",
        "fovExtDesktop": 30,
        "fovIntDesktop": 80,
        "fovExtMobile": 70,
        "fovIntMobile": 80,
      },
      "STARIA LUJO": {
        "model": "./models/STARIA_PREMIUM/scene.glb",
        "fovExtDesktop": 30,
        "fovIntDesktop": 80,
        "fovExtMobile": 60,
        "fovIntMobile": 80,
      },
      "VENUE LIMITED AT": {
        "model": "./models/VENUE_LIMITED_AT/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },
      "HB20 ADVANCE": {
        "model": "./models/HB20/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },
      "HB20S ADVANCE": {
        "model": "./models/HB20S/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },
      "CRETA PREMIUM": {
        "model": "./models/CRETA_PREMIUM/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },
      "KONA HEV LIMITED": {
        "model": "./models/KONA_HIBRIDA/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },
      "SANTA FE HEV LIMITED 4x4": {
        "model": "./models/SANTAFE_LIMITED/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },

      "GRAND i10 AT PREMIUM": {
        "model": "./models/GRANDi10_AT_PREMIUM/scene.glb",
        "fovExtDesktop": 28,
        "fovIntDesktop": 80,
        "fovExtMobile": 55,
        "fovIntMobile": 80,
      },
    }
  }
}